import StickyProgramAndSignup from '@/components/StickyProgramAndSignup';
import { LayoutProps } from '.';
import PageTop from '@/components/PageTop';

export const PersonInfoPageLayout = ({ children, properties, image }: LayoutProps) => {
  return (
    <>
      <PageTop image={image} properties={properties} />

      <StickyProgramAndSignup
        isActive={properties?.isActive}
        program={properties?.programLink?.[0] as Record<string, any>}
        signup={properties?.signUpLink?.[0] as Record<string, any>}
      />

      <section>{children}</section>
    </>
  );
};

export default PersonInfoPageLayout;
